var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5.5C3.365.5 0 3.865 0 8s3.365 7.5 7.5 7.5S15 12.135 15 8 11.635.5 7.5.5Zm0 1.154A6.338 6.338 0 0 1 13.846 8 6.338 6.338 0 0 1 7.5 14.346 6.338 6.338 0 0 1 1.154 8 6.338 6.338 0 0 1 7.5 1.654ZM5.319 4.989l-.83.83L6.671 8l-2.182 2.181.83.83L7.5 8.829l2.181 2.182.83-.83L8.329 8l2.182-2.181-.83-.83L7.5 7.171 5.319 4.989Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossCircle);
export default ForwardRef;